import { FoodsBadge, FoodsTooltip } from "@foodpilot/foods";
import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

export const NonCalculatorActionIcon = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <FoodsTooltip title={t("action.tooltip.noncalculator", "No calculator — impact is qualitative.")}>
            <Stack>
                <FoodsBadge
                    size={3}
                    icon={"compass"}
                    boxProps={{
                        sx: {
                            backgroundColor: theme.custom.dataviz.colorsWithExtra[2].variant[100],
                            borderRadius: theme.spacing(0.5),
                        },
                    }}
                    boxExtraPaddingPx={0}
                />
            </Stack>
        </FoodsTooltip>
    );
};
